import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, memo } from 'react';
import { Image, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import { PageFooter } from '../PageFooter';
import BluePax from '../../../../../../images/bluepax-logo.png';
;
export const PageTwo = memo(({ pharmacy, traderInfo, }) => {
    const styles = StyleSheet.create({
        container: {
            padding: '40px 40px 0px',
        },
        header: {
            padding: '0px 20px',
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
        image: {
            width: 200,
        },
        boxContainer: {
            marginBottom: 5,
            marginTop: 5,
            border: 1.5,
            borderColor: '#003399',
        },
        boxHeader: {
            backgroundColor: '#003399',
            color: 'white',
            textAlign: 'center',
            fontSize: 12,
        },
        boxEntry: {
            paddingLeft: 4,
            paddingTop: 3,
            paddingBottom: 3,
            fontSize: 10,
        },
        description: {
            borderBottom: 2,
            borderBottomColor: '#003399',
            paddingRight: 30,
            paddingLeft: 30,
        },
        descEntry: {
            fontSize: 10,
            paddingTop: 4,
            paddingBottom: 4,
        },
        textBold: {
            alignContent: 'flex-end',
            justifyContent: 'flex-end',
            marginRight: 20,
            marginTop: 30,
            fontSize: 14,
            color: 'dodgerblue',
        },
        boxParent: {
            paddingLeft: 25,
            paddingRight: 25,
        },
        sigContainer: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: 30,
            paddingRight: 30,
        },
        versionText: {
            fontSize: 10,
            justifyContent: 'flex-end',
            alignSelf: 'flex-end',
            paddingBottom: 0,
        },
    });
    const date = dayjs().format('MM/DD/YYYY');
    const entries = useMemo(() => {
        const { ap, dispensing, banking, } = traderInfo;
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        const estimatedMonthlyGeneric = formatter.format(dispensing.estimatedMonthlyGeneric);
        const estimatedMonthlyBrand = formatter.format(dispensing.estimatedMonthlyBrand);
        return [
            { text: 'ADDITIONAL INFORMATION AND PREFERENCES', style: styles.boxHeader, },
            { text: `Pharmacy Name:  ${pharmacy.name}     Type of Pharmacy:  ${pharmacy.pharmacyType}`, style: styles.boxEntry, },
            { text: `Est. monthly brand purchases:  ${estimatedMonthlyBrand}     Est. monthly generic purchases:  ${estimatedMonthlyGeneric}`, style: styles.boxEntry, },
            { text: 'How did you hear about blupax?    Pharmacy Marketplace LLC', style: styles.boxEntry, },
            { text: `How would you like to receive your invoices?  ${banking.receiveInvoices}`, style: styles.boxEntry, },
            { text: `If by email, provide an email for this:  ${pharmacy.email}`, style: styles.boxEntry, },
            { text: `Do you have multiple ship-to facilities?  ${traderInfo.multipleShipToFacilities ? 'Yes' : 'No'}`, style: styles.boxEntry, },
            { text: 'If yes, please attach a listing along with their state licenses: __________________', style: styles.boxEntry, },
            { text: `Are you related to any other facilities?  ${traderInfo.relatedToOtherFacilities ? 'Yes' : 'No'}     If yes, please list:  ${traderInfo.relatedToOtherFacilitiesList || '__________________________'}`, style: styles.boxEntry, },
            { text: 'Do you require a monthly statement?  __X__ Yes ____ No', style: styles.boxEntry, },
            { text: `How should the statement be sent?  ${banking.receiveInvoices}`, style: styles.boxEntry, },
            { text: `If by email, please provide an email address for this:  ${ap.email}`, style: styles.boxEntry, },
            { text: `We provide T3 documents by email. Please provide an email for this:  ${pharmacy.email}`, style: styles.boxEntry, },
            { text: 'Would you also like to receive a printed T3 document with your order? __X__ Yes ____ No', style: styles.boxEntry, }
        ];
    }, [pharmacy]);
    return (_jsx(Page, { size: 'A4', wrap: false, children: _jsxs(View, { style: styles.container, children: [_jsxs(View, { style: styles.header, children: [_jsx(View, { children: _jsx(Image, { style: styles.image, src: BluePax }) }), _jsx(View, { children: _jsx(Text, { style: styles.textBold, children: "Credit Application: Page 2" }) })] }), _jsx(View, { style: styles.boxParent, children: _jsx(View, { style: styles.boxContainer, children: entries.map((entry, index) => (_jsx(Text, { style: entry.style, children: entry.text }, index))) }) }), _jsxs(View, { style: styles.description, children: [_jsx(Text, { style: styles.descEntry, children: "Terms of sale, including terms of payment and charges, for each purchase are agreed to be those specified on the face of each invoice. The customer hereby agrees to pay all costs of collection and legal fees should such action be necessary due to non-payment. The above information is willingly supplied and the creditor is authorized to contact the above bank and trade references in order to establish the creditworthiness of the above named company. If the applicant is not a corporation, the creditor is authorized to obtain credit reports on the proprietors, partners or principals. Should credit availability be granted by the creditor, all decisions with respect to the extension or continuation shall be in the sole discretion of the creditor. The creditor may terminate any credit availability within its sole discretion. Credit terms are NET 30 days upon approval." }), _jsx(Text, { style: styles.descEntry, children: "Applicant acknowledges that BluPax Pharma has the right to discontinue any and all deliveries if an invoice goes past due. Applicant and BluPax Pharma shall maintain the confidentiality of each other\u2019s proprietary information, including, but not limited to, marketing strategies, business plans, financial data and bank accounts, policies and procedures, and other informational material." }), _jsx(Text, { style: styles.descEntry, children: "Applicant shall indemnify BluPax Pharma, its affiliated, successors and assigns, and its and their respective officers, directors, employees, and agents, against and hold the same harmless from, any and all claims, demands, losses, damages, liabilities, actions, judgments, costs and expenses (including settlements, judgments, court costs, and reasonable attorneys\u2019 fees) of any nature or kind whatsoever (collectively, the \u201Cdamages\u201D) arising out of or resulting from, directly or indirectly, any grossly negligent or willful act or omission by applicant or applicant\u2019s failure to perform any obligation under taken or covenant made in this agreement, except to the extent that the damages arise out of or result from the grossly negligent or willful acts or omissions or BluPax Pharma." }), _jsx(Text, { style: styles.descEntry, children: "* Applicant agrees to BluPax Pharma\u2019s Return Policy: (https://www.blupaxpharma.com/return-policy/) and Privacy Policy: (https://www.blupaxpharma.com/privacy-policy/)." }), _jsx(Text, { style: styles.descEntry, children: "All terms herein are governed by New Jersey law. For proprietors, partners, s-corporations in the U.S., I authorize the seller and their assigns to obtain a consumer credit report on my credit history." })] }), _jsxs(View, { style: styles.sigContainer, children: [_jsxs(View, { children: [_jsx(Text, { style: styles.boxEntry }), _jsx(Text, { style: styles.boxEntry, children: `Name:  ${traderInfo.owner.firstName} ${traderInfo.owner.lastName}` }), _jsx(Text, { style: styles.boxEntry, children: "Title:  Owner" }), _jsx(Text, { style: styles.boxEntry, children: `Date:  ${date}` }), _jsx(Text, { style: styles.boxEntry, children: "Signature:" })] }), _jsx(View, { style: styles.boxParent, children: _jsx(Text, { style: styles.versionText, children: "V:04.21" }) })] }), _jsx(PageFooter, {})] }) }));
});
